// const Header = () => import('./header')
import {Toast, Rate} from 'vant'
import comms from './common'
const SwipeBanner = () => import('./swiper/SwipeBanner')
const SwiperInfo = () => import('./swiper/SwiperInfo')
const SwipeActive = () => import('./swiper/SwipeActive')

const LjbHeader = () => import('./LjbHeader')
const PopupLogin = () => import('./popup/PopupLogin')
const PopupConsulting = () => import('./popup/consulting')
const ListActivity = () => import('./list/ListActivity')
const ListField = () => import('./list/ListField')
const ListService = () => import('./list/ListService')
const ListStep = () => import('./list/ListStep')

const ListOrderInfo = () => import('./list/listOrderInfo')
const PopupItem = () => import('./popup/PopupItem')
const PopupToast = () => import('./popup/PopupToast')
const PopupPhone = () => import('./popup/PopupPhone')
const PopupUpGlide = () => import('./popup/PopupUpglide')
const PopupCoupon = () => import('./popup/PopupCoupon')
const PopupUserThree = () => import('./popup/PopupUserThree')
const PopupAgainConsul = () => import('./popup/PopupAgainConsul')

const ModuleTitle = () => import('./title/ModuleTitle')
const TextTitle = () => import('./title/TextTitle')
const PupopTitle = () => import('./title/PupopTitle')

const SelectBar = () => import('./SelectBar')
const PayList = () => import('./pay/payList')
const PopupPay = () => import('./pay/PopupPay')
const LjbItem = () => import('./LjbItem')
const OrderState = () => import('./orderState')

const UserModule = () => import('./views/UserModule')
const UserBanner = () => import('./views/UserBanner')
const UserList = () => import('./views/UserList')
const OrderItem = () => import('./views/OrderItem')
const DiscountCoupon = () => import('./views/DiscountCoupon')
const EvaluateAbout = () => import('./views/EvaluateAbout')
const SplitTag = () => import('./views/SplitTag')
const TextareaBox = () => import('./views/TextareaBox')
const LawyerBox = () => import('./views/lawyerBox')
const DynamicList = () => import('./views/DynamicList')
const SubBanner = () => import('./views/SubBanner')
const PdfTranslate = () => import('./views/PdfTranslate')
const LoadingView = () => import('./views/LoadingView')
const EvalComp = () => import('./views/EvalComp')
const TimeCard = () => import('./views/TimeCard')
const ChooseTime = () => import('./views/ChooseTime')
const ChooseArea = () => import('./views/ChooseArea')
const AddInfo = () => import('./views/ChooseArea')
const OrderInfo = () => import('./views/OrderInfo')
const CommonProblems = () => import('./views/CommonProblems')

const install = function (Vue) {
  Object.values(CommonComponents).forEach((component, b, c) => {
    if ((typeof component === 'object') && component.name) {
      Vue.component(component.name, component)
    }
  })
}

/* istanbul ignore if */
if (typeof window !== 'undefined' && window.Vue) {
  install(window.Vue)
}

// 公共组件自动引用 装载
const CommonComponents = Object.assign({
  install,
  Toast,
  Rate
}, comms)

export default CommonComponents

export {
  CommonComponents,
  SwipeBanner,
  SwiperInfo,
  SwipeActive,
  LjbHeader,
  PopupLogin,
  PopupConsulting,
  ListActivity,
  ListField,
  ListStep,
  ListOrderInfo,
  ListService,
  PopupItem,
  PopupToast,
  PopupPay,
  PopupPhone,
  PopupUpGlide,
  PopupCoupon,
  ModuleTitle,
  TextTitle,
  PupopTitle,
  SelectBar,
  PayList,
  LjbItem,
  OrderState,
  OrderItem,
  UserModule,
  UserBanner,
  UserList,
  DiscountCoupon,
  EvaluateAbout,
  SplitTag,
  TextareaBox,
  LawyerBox,
  DynamicList,
  SubBanner,
  PdfTranslate,
  LoadingView,
  EvalComp,
  TimeCard,
  ChooseTime,
  ChooseArea,
  AddInfo,
  OrderInfo,
  PopupUserThree,
  CommonProblems,
  PopupAgainConsul

}



// WEBPACK FOOTER //
// ./src/components/index.js